export default __webpack_public_path__ + "static/media/covid.abf21aa3.png";